import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import './index.css';
import App from './App';
import { initWebVitals, trackResourceTiming, trackNavigationTiming, trackLongTasks } from './shared/utils/performanceMonitoring';
import { logger } from './shared/utils/logger';

// Make logger available globally for debugging in development
if (process.env.NODE_ENV === 'development') {
  window.logger = logger;
  window.enableDebugMode = () => logger.enableDebugMode();
  window.disableDebugMode = () => logger.disableDebugMode();
}

// Initialize performance monitoring
initWebVitals();
trackResourceTiming();
trackNavigationTiming();
trackLongTasks();

logger.info('Application starting', { 
  environment: process.env.NODE_ENV,
  timestamp: new Date().toISOString()
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
